import React from 'react'
import "./styles.css";
import { ReactComponent as BackIcon } from "common/assets/svg/leftArrow.svg";
import { ReactComponent as CloseIcon } from "common/assets/svg/closeIcon.svg";



export interface AuthHeaderInterface {
    title: string;
    isShowBackArrow: boolean;
    isShowCloseButton: boolean;
    onClose: () => void;
    onBack: () => void;
  }


const AuthHeader = (props:AuthHeaderInterface) => {

    const {title,isShowBackArrow,isShowCloseButton,onClose,onBack} = props;

  return (
    <React.Fragment>
        <div id="headerContainer-ad">
            {isShowBackArrow ? <BackIcon  id="header-icon-ad" onClick={onBack}/> : <div/>}
            <span id={"header-title-ad"}>{title}</span>
            {isShowCloseButton ? <CloseIcon className="header-icon" onClick={onClose}/> : <div/>}
        </div>
    </React.Fragment>
  )
}

export default AuthHeader